var hasNativePerformanceNow = typeof performance === "object" && typeof performance.now === "function";
export var now = hasNativePerformanceNow
    ? function () { return performance.now(); }
    : function () { return Date.now(); };
//# sourceMappingURL=now.js.map